// Components
import { Carousel, Slide } from 'vue-carousel'
import TextComponent from '@/components/text/component'
import ProductPreview from '@/components/product-preview/component'

export default {
  name: 'frames',
  components: { TextComponent, ProductPreview, Carousel, Slide },
  props: [ 'carousel', 'frames' ],
  data () {
    return {
      adding: false
    }
  },
  computed: {
    narrow () {
      return true
    }
  },
  methods: { }
}



// WEBPACK FOOTER //
// ./src/components/frames/script.js